import Link from 'next/link';
import React from 'react';

interface SuperLinkProps extends React.HTMLProps<HTMLAnchorElement> {
  useAnchor?: boolean;
}

export const SuperLink = ({
  href,
  useAnchor,
  ...props
}: SuperLinkProps): React.ReactElement => {
  if (useAnchor) {
    return (
      <a href={href} {...props}>
        {props.children}
      </a>
    );
  }

  return <Link href={href || ''} {...props} passHref />;
};
